import React from 'react';

export default function UnifiedMessageList({
  styles,
  data,
  currentUserEmail,
  renderMessageContent,
  onTopReached,
  hasOlderMessages,
  isLoadingOlder = false,
  olderHintText = 'Pull down to load older messages',
  loadingOlderText = 'Loading older messages...',
  selectableText = false,
  emptyText = 'No messages yet. Start the conversation!',
}) {
  const listRef = React.useRef();
  
  React.useEffect(() => {
    if (listRef.current && data && data.length > 0) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [data]);

  return (
    <div ref={listRef} style={{ ...styles.chatListContent, overflowY: 'auto', height: '100%', backgroundColor: '#ffffff', color: '#000000' }}>
      {(hasOlderMessages || isLoadingOlder) && (
        <div style={{ paddingTop: 2, paddingBottom: 8, textAlign: 'center', backgroundColor: '#ffffff' }}>
          {isLoadingOlder ? (
            <span className="spinner" style={{ width: 16, height: 16, border: '2px solid #000000', borderTop: '2px solid #ffffff', borderRadius: '50%', display: 'inline-block', animation: 'spin 1s linear infinite', marginRight: 8 }} />
          ) : null}
          <span style={{ ...styles.olderHintText, color: '#374151' }}>{isLoadingOlder ? loadingOlderText : `↓ ${olderHintText}`}</span>
          <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
        </div>
      )}
      
      {data && data.length > 0 ? (
        data.map((item, idx) => {
          const mine = item?.user_email === currentUserEmail;
          const isAI = item?.user_email === 'ai-agent@effiez.com.au' || item?.user_email === '@ai-agent';
          const isSystem = !item?.user_email || item?.user_email === 'system' || item?.user_email === 'System';
          const content = renderMessageContent ? renderMessageContent(item) : (item?.message_content || '-');
          const currentTs = item?.ctimestamp || item?.timestamp || item?.createdAt;
          const messageTime = currentTs ? new Date(currentTs).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';
          
          // Pure monochrome inverted architecture (White backgrounds / Black text)
          let bubbleStyle = { 
            ...styles.msgBubble, 
            backgroundColor: '#ffffff', 
            color: '#000000', 
            borderColor: '#d1d5db',
            borderStyle: 'solid',
            borderWidth: '1px'
          };
          let userLabel = item?.user_email || 'user';
          let labelColor = '#000000';
          let icon = null;

          if (mine) {
            bubbleStyle = { 
              ...styles.msgBubble, 
              ...styles.msgRight, 
              backgroundColor: '#ffffff', 
              color: '#000000',
              borderColor: '#d1d5db'
            };
            userLabel = 'You';
            labelColor = '#000000';
          } else if (isAI) {
            bubbleStyle = { 
              ...styles.msgBubble, 
              backgroundColor: '#ffffff', 
              color: '#000000', 
              borderColor: '#d1d5db' 
            };
            userLabel = '';
            labelColor = '#000000';
            icon = <span style={{ fontSize: 13, marginRight: 6, filter: 'grayscale(1)' }}>🤖</span>;
          } else if (isSystem) {
            bubbleStyle = { 
              ...styles.msgBubble, 
              backgroundColor: '#f0f0f2', 
              color: '#000000', 
              borderColor: '#d1d5db' 
            };
            userLabel = 'System';
            labelColor = '#374151';
            icon = <span style={{ fontSize: 13, marginRight: 6, filter: 'grayscale(1)' }}>ℹ️</span>;
          } else {
            bubbleStyle = { 
              ...styles.msgBubble, 
              ...styles.msgLeft, 
              backgroundColor: '#ffffff', 
              color: '#000000',
              borderColor: '#d1d5db'
            };
          }

          return (
            <div key={idx} style={{ backgroundColor: '#ffffff' }}>
              <div style={bubbleStyle}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  {icon}
                  <span style={{ ...styles.msgUser, color: labelColor, fontWeight: '500' }}>{userLabel}</span>
                </div>
                <span style={{ ...styles.msgText, color: '#000000', userSelect: selectableText ? 'text' : 'none' }}>{content || '-'}</span>
                {messageTime ? <div style={{ ...styles.msgTime, color: '#374151', fontSize: '11px', marginTop: '4px' }}>{messageTime}</div> : null}
              </div>
            </div>
          );
        })
      ) : (
        <div style={{ textAlign: 'center', color: '#374151', marginTop: 32, fontSize: 14, backgroundColor: '#ffffff' }}>{emptyText}</div>
      )}
    </div>
  );
}